export const staticSeo = {
  "/": {
    title: "Qualitas Global | AI Data Annotation & Collection Services",
    description:
      "In-house AI data annotation, data collection and generative AI services. 97%+ quality with multi-stage QA. Start with a risk-free pilot.",
  },
  "/contact-us": {
    title: "Contact Us | Qualitas Global",
    description:
      "Tell us about your AI data annotation or collection project. Share your use case, volume and timeline and get a tailored plan and quote.",
  },
  "/careers": {
    title: "Careers | Qualitas Global",
    description:
      "Join Qualitas Global and build your career alongside the future of AI. Explore open roles in data annotation, sales, finance, HR and marketing.",
  },
  "/about-us": {
    title: "About Us | Qualitas Global",
    description:
      "Since 2014 Qualitas Global has processed 950M+ images and videos for AI teams, with in-house annotators and 97%+ quality across 20+ industries.",
  },
  "/ai-infrastructure": {
    title: "AI Infrastructure Services | Qualitas Global",
    description:
      "Data annotation, data collection and generative AI services under one roof. In-house teams, multi-stage QA and a risk-free pilot to begin.",
  },
  "/ai-infrastructure/ai-data-operations": {
    title: "AI Data Operations & Annotation Services | Qualitas Global",
    description:
      "Image, video, text, audio and 3D point cloud annotation with human-in-the-loop QA. 97%+ quality tracked daily. Request a free pilot.",
  },
  "/ai-infrastructure/data-collection": {
    title: "AI Data Collection Services | Qualitas Global",
    description:
      "Custom image, video, audio and text data collection for AI training, sourced and validated to your specification. Request a free pilot.",
  },
  "/ai-infrastructure/generative-ai": {
    title: "Generative AI Data Services | Qualitas Global",
    description:
      "Human-verified data for generative AI and LLM teams, including preference ranking, evaluation and prompt-response annotation, with multi-stage QA.",
  },
  "/industries": {
    title: "Industries We Serve | Qualitas Global",
    description:
      "AI data annotation for 20+ industries, from ADAS and robotics to healthcare, retail and defense. Domain-trained teams and multi-stage QA.",
  },
  "/global-capability": {
    title: "Global Capability Centers & Business Solutions | Qualitas Global",
    description:
      "Dedicated staffing, KPO, BPO and build-operate-transfer / Lean GCC models from Qualitas Global, built on secure in-house operations and multi-stage QA.",
  },
  "/global-capability/dedicated-staffing": {
    title: "Dedicated Staffing Services | Qualitas Global",
    description:
      "Dedicated, trained teams that work as an extension of yours, managed by Qualitas Global with secure operations and multi-stage quality checks.",
  },
  "/global-capability/kpo": {
    title: "Knowledge Process Outsourcing (KPO) Services | Qualitas Global",
    description:
      "Research, analysis and domain-led knowledge work delivered by trained in-house teams, with multi-stage QA and secure processes.",
  },
  "/global-capability/bot-lean-gcc": {
    title: "Build-Operate-Transfer (BOT) / Lean GCC Services | Qualitas Global",
    description:
      "Set up a dedicated delivery centre with Qualitas Global, run it with our teams, then transfer it to you when you are ready.",
  },
  "/global-capability/bpo": {
    title: "Business Process Outsourcing (BPO) Services | Qualitas Global",
    description:
      "Scalable back-office and data-driven process outsourcing from trained in-house teams, with multi-stage QA and secure operations.",
  },
  "/resources/blogs": {
    title: "Blog: AI Data Annotation & Collection Insights | Qualitas Global",
    description:
      "Articles on data annotation, data collection, quality assurance and AI training data from the Qualitas Global team.",
  },
  "/resources/media": {
    title: "Media & News | Qualitas Global",
    description:
      "Press coverage, announcements and media resources from Qualitas Global.",
  },
  "/why-us": {
    title: "Why Choose Qualitas Global | AI Data Annotation Partner",
    description:
      "Why AI teams choose Qualitas Global: in-house annotators, multi-stage QA with 97%+ quality, secure operations and a risk-free pilot to start.",
  },
  "/privacy-policy": {
    title: "Privacy Policy | Qualitas Global",
    description:
      "How Qualitas Global collects, uses and protects personal information, how consent works, and how to exercise your data rights.",
  },
  "/website-terms": {
    title: "Website Terms of Use | Qualitas Global",
    description:
      "The terms that apply when you use the Qualitas Global website.",
  },
};

export const industrySeo = {
  "aerial-drones": {
    title: "Aerial & Drone Data Annotation Services | Qualitas Global",
    description:
      "Drone imagery, video and sensor data annotation with multi-stage QA, so your aerial AI models train on labels they can trust. Request a free pilot.",
  },
  "agritech-precision-agriculture": {
    title: "Agri-Tech Data Annotation Services | Qualitas Global",
    description:
      "Crop, weed, disease and livestock annotation across image, video, drone and satellite data. Multi-stage QA for agritech AI. Request a free pilot.",
  },
  "adas-autonomous-vehicles": {
    title: "ADAS & Autonomous Vehicle Annotation | Qualitas Global",
    description:
      "Camera, LiDAR and radar annotation for ADAS and autonomous driving, with multi-stage QA and retraining as your guidelines evolve. Request a free pilot.",
  },
  "banking-finance-insurance": {
    title: "BFSI Data Annotation Services | Qualitas Global",
    description:
      "Document, KYC, claims and damage annotation for banking, financial services and insurance AI, with multi-stage QA in a secure facility.",
  },
  "construction": {
    title: "Construction Data Annotation Services | Qualitas Global",
    description:
      "Site image, drone, video and point cloud annotation for safety and progress AI. Worker, equipment and PPE labeling with multi-stage QA.",
  },
  "defense-security-surveillance": {
    title: "Defense & Security Data Annotation | Qualitas Global",
    description:
      "CCTV, thermal, drone and satellite annotation for threat detection and tracking AI, delivered in a secure facility with multi-stage QA.",
  },
  "education": {
    title: "Education Data Annotation Services | Qualitas Global",
    description:
      "Handwriting, speech, equation and video annotation for learning AI, with multi-stage QA and labeling rules built around your curriculum.",
  },
  "energy-utilities": {
    title: "Energy & Utilities Data Annotation | Qualitas Global",
    description:
      "Drone, thermal and geospatial annotation for solar, wind and grid inspection AI. Defect and asset labeling with multi-stage QA.",
  },
  "fashion-retail-ecommerce": {
    title: "Retail & Fashion Data Annotation Services | Qualitas Global",
    description:
      "SKU, shelf, apparel and in-store video annotation for retail and e-commerce AI, backed by multi-stage QA. Request a free pilot.",
  },
  "gaming-entertainment-media": {
    title: "Media & Entertainment Data Annotation | Qualitas Global",
    description:
      "Video, image, audio and text annotation for scene tagging, brand exposure, captioning and moderation AI, with multi-stage QA.",
  },
  "geospatial-satellite": {
    title: "Geospatial & Satellite Data Annotation | Qualitas Global",
    description:
      "Satellite, LiDAR, SAR and map annotation for mapping and earth observation AI, with geometry validation and multi-stage QA.",
  },
  "government-smart-cities": {
    title: "Smart City & Public Sector Annotation | Qualitas Global",
    description:
      "Traffic, aerial, geospatial and document annotation for government and smart city AI, with multi-stage QA under secure controls.",
  },
  "healthcare-medical-biological": {
    title: "Medical & Healthcare Data Annotation | Qualitas Global",
    description:
      "Medical image, keypoint and clinical document annotation for healthcare AI, with domain-trained reviewers and multi-stage QA.",
  },
  "hospitality-tourism": {
    title: "Hospitality & Tourism Data Annotation | Qualitas Global",
    description:
      "Property image, review text and occupancy video annotation for hospitality and travel AI, with multi-stage QA. Request a free pilot.",
  },
  "logistics": {
    title: "Logistics & Warehouse Data Annotation | Qualitas Global",
    description:
      "Parcel, container, document and warehouse video annotation for logistics AI, with multi-stage QA. Request a free pilot.",
  },
  "manufacturing": {
    title: "Manufacturing Data Annotation Services | Qualitas Global",
    description:
      "Defect, weld, PCB and sensor data annotation for inspection and predictive maintenance AI, with multi-stage QA.",
  },
  "marine-maritime": {
    title: "Marine & Maritime Data Annotation | Qualitas Global",
    description:
      "Camera, sonar, radar and LiDAR annotation for vessel, underwater and port AI, with multi-stage QA. Request a free pilot.",
  },
  "robotics": {
    title: "Robotics Data Annotation Services | Qualitas Global",
    description:
      "Image, video and 3D annotation for manipulation, imitation learning, VLM and navigation models, with multi-stage QA.",
  },
  "sports-analytics": {
    title: "Sports Data Annotation & Event Tagging | Qualitas Global",
    description:
      "Player tracking, event tagging and match video annotation for sports AI, backed by a team working on sports annotation since 2007.",
  },
  "technology-telecommunications": {
    title: "Technology & Telecom Data Annotation | Qualitas Global",
    description:
      "Annotated datasets for network optimization, fraud detection and customer behavior AI, with multi-stage QA that scales from pilot to production.",
  },
};

export const serviceSeoOverrides = {
  "/ai-infrastructure/ai-data-operations/text-annotation": {
    title: "Text Annotation Services for NLP & LLMs | Qualitas Global",
    description:
      "Sentiment, intent, entity, dialogue and content-safety labelling by trained in-house annotators, verified through multi-stage QA. Start with a risk-free pilot.",
  },
  "/ai-infrastructure/ai-data-operations/document-annotation": {
    title: "Document Annotation Services for AI Models | Qualitas Global",
    description:
      "Document classification, key-value, table and form-field annotation for IDP and OCR models, delivered by in-house teams with multi-stage QA.",
  },
  "/ai-infrastructure/ai-data-operations/image-annotation": {
    title: "Image Annotation Services for Computer Vision | Qualitas Global",
    description:
      "Bounding boxes, polygons, segmentation and keypoints by trained in-house annotators, with multi-stage QA for model-ready accuracy. Try a risk-free pilot.",
  },
  "/ai-infrastructure/ai-data-operations/video-annotation": {
    title: "Video Annotation Services for AI Models | Qualitas Global",
    description:
      "Frame-by-frame object tracking, event tagging and action labelling turning raw footage into model-ready data, with multi-stage QA and in-house teams.",
  },
  "/ai-infrastructure/ai-data-operations/audio-annotation": {
    title: "Audio Annotation Services for Speech & Sound AI | Qualitas Global",
    description:
      "Transcription, speaker labelling, sound-event and language annotation for speech and LLM models, checked through multi-stage QA by in-house teams.",
  },
  "/ai-infrastructure/ai-data-operations/lidar-annotation": {
    title: "3D Point Cloud & LiDAR Annotation Services | Qualitas Global",
    description:
      "3D cuboids, point-level segmentation and object tracking on LiDAR and sensor-fusion data for ADAS and robotics, with multi-stage QA and in-house teams.",
  },
  "/ai-infrastructure/ai-data-operations/radar-annotation": {
    title: "RADAR Data Annotation Services for AI | Qualitas Global",
    description:
      "Object, range-Doppler and tracking annotation for RADAR data used in automotive and defense AI, delivered by trained in-house teams with multi-stage QA.",
  },
  "/ai-infrastructure/ai-data-operations/thermal-infrared-annotation": {
    title: "Thermal & Infrared Image Annotation Services | Qualitas Global",
    description:
      "Precise annotation of thermal and infrared imagery for surveillance, inspection and night-vision AI, with multi-stage QA by trained in-house annotators.",
  },
  "/ai-infrastructure/ai-data-operations/sonar-annotation": {
    title: "Sonar Data Annotation for Underwater AI | Qualitas Global",
    description:
      "Object, seabed and target annotation on sonar imagery for marine and underwater AI models, delivered by trained in-house teams with multi-stage QA.",
  },
  "/ai-infrastructure/ai-data-operations/medical-annotation": {
    title: "Medical Data Annotation Services | Qualitas Global",
    description:
      "Radiology and clinical image annotation by domain-trained teams for diagnostic AI, handled under strict privacy controls with multi-stage quality review.",
  },
  "/ai-infrastructure/ai-data-operations/sports-annotation": {
    title: "Sports Analytics & Video Annotation Services | Qualitas Global",
    description:
      "Player, ball, jersey and event tracking across 20+ sports, frame by frame, by an in-house team working on sports annotation since 2007.",
  },
  "/ai-infrastructure/ai-data-operations/egocentric-annotation": {
    title: "Egocentric Video Annotation for Robotics & Embodied AI | Qualitas Global",
    description:
      "First-person video annotation of hands, objects, actions and intent, so robots and embodied AI learn to see, understand and act. Start with a risk-free pilot.",
  },
  "/ai-infrastructure/data-collection/egocentric-data-collection": {
    title: "Egocentric Data Collection for Robotics & AR/VR | Qualitas Global",
    description:
      "Multimodal first-person data from head-mounted cameras and wearables for robotics, AR/VR and embodied AI. Request a sample dataset.",
  },
  "/ai-infrastructure/data-collection/synthetic-data-collection": {
    title: "Synthetic Dataset & Scenario Creation | Qualitas Global",
    description:
      "Synthetic datasets and scenarios built to your specification for AI training and validation. Request a sample to evaluate fit before scaling.",
  },
  "/ai-infrastructure/data-collection/text-data-collection": {
    title: "Text Data Collection for NLP & LLM Training | Qualitas Global",
    description:
      "Rights-cleared, structured text data across publications, legal, medical, support logs and more, validated to your specification. Request a sample dataset.",
  },
  "/ai-infrastructure/data-collection/audio-data-collection": {
    title: "Audio & Speech Data Collection in 20+ Languages | Qualitas Global",
    description:
      "Consented monologues, dialogues and call-centre speech across 20+ languages for ASR, TTS and voice assistants. Request a sample dataset.",
  },
  "/ai-infrastructure/data-collection/image-data-collection": {
    title: "Image Data Collection for Computer Vision | Qualitas Global",
    description:
      "Consented, diverse image training data for machine learning, collected globally to your protocol across human, urban, object, medical and document categories.",
  },
  "/ai-infrastructure/data-collection/video-data-collection": {
    title: "Video Data Collection for AI Training | Qualitas Global",
    description:
      "Consented real-world video across human, industrial, public-safety and retail settings, collected to your scenario and camera requirements. Request a sample.",
  },
  "/ai-infrastructure/data-collection/web-data-collection": {
    title: "Web Data Collection & Scraping Services | Qualitas Global",
    description:
      "Structured, validated web data across commerce, finance, media and public records, extracted to your schema and delivered in your pipeline's format.",
  },
  "/ai-infrastructure/data-collection/adas-data-collection": {
    title: "ADAS Data Collection for Autonomous Driving | Qualitas Global",
    description:
      "Multi-sensor road and in-cabin driving data across weather, lighting and traffic, collected to your sensor setup. Indian road datasets ready to license.",
  },
};

export const operationsSeo = (slug) =>
  serviceSeoOverrides[`/ai-infrastructure/ai-data-operations/${slug}`] || null;

export const collectionSeo = (slug) =>
  serviceSeoOverrides[`/ai-infrastructure/data-collection/${slug}`] || null;